import { useGetRequest, RequestResponse } from "../hook/useRequest";

const useFetchCards = (username: string): RequestResponse => {
    return useGetRequest(`/card/${username}`);
};

export { useFetchCards };
